"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var Strategy_1 = require("./Strategy");
/**
 * Strategy for following more competitors or specific group of competitors.
 *
 * @author RV
 */


var MultiTargetStrategy =
/*#__PURE__*/
function (_Strategy_1$Strategy) {
  _inherits(MultiTargetStrategy, _Strategy_1$Strategy);

  /**
   * @param competitorIds
   */
  function MultiTargetStrategy(competitorIds) {
    var _this;

    _classCallCheck(this, MultiTargetStrategy);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(MultiTargetStrategy).call(this));
    _this.competitorIds = competitorIds;
    return _this;
  }

  return MultiTargetStrategy;
}(Strategy_1.Strategy);

exports.MultiTargetStrategy = MultiTargetStrategy;